import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Reportmodal from "../Reportmodal/index";
import url from "../../config/axios";
import "../../pages/suggestionmodal/Style.css";
import { getAsset } from "../../helpers/helper";
import Loader from "../Loader/index";
import { FailedNotify } from "../../constants/tostify";
const Report = ({ setSuggest, shopid }) => {
  const [openBox, setOpenBox] = useState(1);
  const [reportM, setreportM] = useState();
  const [reporting, setReporting] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    url
      .get(`reportshop/?shopId=${shopid}`)
      .then((res) => {
        

        if (res?.data?.reports?.length > 0) {
          setReporting(res?.data?.reports);
          setLoading(false);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  }, []);

  const stateHandler = (e) => {
    console.log("e", e);
    setOpenBox(0);
    setreportM(e);
  };
  useEffect(() => {
    if (openBox === 1) {
      setreportM(false);
    }
  });
  const statezero = (e) => {
    setSuggest(false);
  };

  return (
    <>
      {reportM && (
        <Reportmodal
          setOpenBox={setOpenBox}
          reportM={reportM}
          setreportM={setreportM}
          shopid={shopid}
        />
      )}

      {openBox === 1 && (
        <div>
          <Modal.Header
            className="me-3 suggst-btn"
            closeButton
            onClick={() => setSuggest(0)}
          >
            <Modal.Title className="ms-3">Report</Modal.Title>
          </Modal.Header>
          <hr />
          {loading === true ? (
            <Loader />
          ) : (
            <div className="report-hgt noscroll">
              {reporting && reporting.length > 0 ? (
                reporting.map((e, index) => (
                  <Row
                    key={e._id}
                    className={`${
                      index % 2 === 0 ? "bg-light" : "bg-white"
                    } p-0 m-0 mb-2 pt-2 pb-2`}
                  >
                    <Col className="mt-2 m-0 p-0" lg="1">
                      <img
                        className="ms-3 pi-ck"
                        src={getAsset(e.imageUrl)}
                        alt=""
                        crossOrigin="anonymous"
                      />
                    </Col>
                    <Col className="mt-2" lg="9">
                      <h6 className="-size m-0 ms-3">{e.fullname}</h6>
                      <p className="PHERA-0 mb-0 ms-3">{e.reportType}</p>
                      <p className="PHERA mb-0 ms-3">{e.description}</p>
                    </Col>
                    <Col className="p-0 m-0" lg="2">
                      <div className="d-flex">
                        <Col>
                          <button
                            type="button"
                            className="button-01 ms-4 mt-5"
                            onClick={() => {
                              stateHandler(e._id);
                            }}
                          >
                            Read
                          </button>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                ))
              ) : (
                <div className="d-flex justify-content-center">
                  <h5>No Data Found</h5>
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default Report;
